import React, { useEffect } from "react";
import TopToBottom from "../../lib/TopToBottom";

function BackToTop({ className }) {
  useEffect(() => {
    TopToBottom(".binduz-er-back-to-top");
  });
  return (
    <>
      <div className={`binduz-er-back-to-top ${className || ""}`}>
        <p>
          SHKO LART <i className="fal fa-long-arrow-right"></i>
        </p>
      </div>
    </>
  );
}

export default BackToTop;
